export default __webpack_public_path__ + "static/media/EM0920.34I-23053_-16454_0.4262cf2a.jpg";